// <s-gallery-sync> moves the photo of the chosen color to the front of the product gallery.
// Color inputs carry data-media-id; gallery items carry the same id on data-media-id.
class GallerySync extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      const mediaId = event.target?.dataset?.mediaId;
      if (mediaId) this.#show(mediaId);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #show(mediaId) {
    const gallery = this.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const item = gallery.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`);
    if (!item) return;

    gallery.querySelectorAll('[data-media-id]').forEach((el) => { el.style.order = ''; });
    item.style.order = '-1';

    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    gallery.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
  }
}

customElements.define('s-gallery-sync', GallerySync);
